<app-modal
  [show]="show"
  [title]="title"
  [confirmButtonLabel]="isAddMode ? 'Allocate' : 'Save Changes'"
  [processing]="processing"
  (onClose)="close()"
  (onConfirm)="save()">

  <form [formGroup]="form" class="space-y-5">

    <!-- Add mode: pick a guest from unallocated -->
    @if (isAddMode) {
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-800 dark:text-white">Guest</label>
        @if (context.candidates.length === 0 && !selectedGuest) {
          <p class="rounded-lg border border-gray-200 bg-gray-50 p-3 text-sm text-gray-500 dark:border-gray-700 dark:bg-gray-800/40 dark:text-gray-400">
            No unallocated guests are flagged for accommodation. Mark a guest in the Guests tab first.
          </p>
        } @else {
          <select
            class="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white"
            [value]="form.controls.guest_id.value ?? ''"
            (change)="onGuestSelected($any($event.target).value ? +$any($event.target).value : null)">
            <option value="" disabled>Select a guest…</option>
            @for (g of context.candidates; track g.id) {
              <option [value]="g.id">{{ g.full_name }}</option>
            }
            @if (selectedGuest && !context.candidates.length) {
              <option [value]="selectedGuest.id">{{ selectedGuest.full_name }}</option>
            }
          </select>
        }
      </div>
    } @else {
      <div class="rounded-lg border border-gray-200 bg-gray-50 p-3 dark:border-gray-700 dark:bg-gray-800/40">
        <div class="text-sm font-medium text-gray-900 dark:text-white">
          {{ selectedGuest?.full_name }}
        </div>
        <div class="text-xs text-gray-600 dark:text-gray-400">
          Allocated to {{ context.roomLabel }}
        </div>
      </div>
    }

    @if (selectedGuest) {
      <!-- Read-only contact details from guest record -->
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Name</label>
          <div class="text-sm text-gray-900 dark:text-white">{{ selectedGuest.full_name }}</div>
        </div>
        <div>
          <label class="mb-1 block text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Email</label>
          <div class="text-sm text-gray-900 dark:text-white">{{ selectedGuest.email || '—' }}</div>
        </div>
      </div>

      <!-- Editable fields per TVG-60 -->
      <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div>
          <label class="mb-1 block text-sm font-medium text-gray-800 dark:text-white">Mobile</label>
          <input type="text" formControlName="mobile"
                 class="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white" />
        </div>
        <div>
          <label class="mb-1 block text-sm font-medium text-gray-800 dark:text-white">Role</label>
          <input type="text" formControlName="accommodation_role" placeholder="e.g. Bridesmaid"
                 class="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white" />
        </div>
        <div>
          <label class="mb-1 block text-sm font-medium text-gray-800 dark:text-white">Emergency Contact Name</label>
          <input type="text" formControlName="accommodation_emergency_contact_name"
                 class="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white" />
        </div>
        <div>
          <label class="mb-1 block text-sm font-medium text-gray-800 dark:text-white">Emergency Contact Number</label>
          <input type="text" formControlName="accommodation_emergency_contact_number"
                 class="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white" />
        </div>
      </div>

      <div class="flex items-center gap-2">
        <input id="acc-breakfast" type="checkbox" formControlName="accommodation_breakfast"
               class="h-4 w-4 rounded border-gray-300 text-brand-500 focus:ring-brand-500" />
        <label for="acc-breakfast" class="text-sm text-gray-800 dark:text-white">Wants breakfast</label>
      </div>

      <!-- Room selector. In add mode opened from a room card it's pre-set; from
           the unallocated panel the user picks. In edit mode it's editable. -->
      <div>
        <label class="mb-1 block text-sm font-medium text-gray-800 dark:text-white">Room</label>
        <input type="text" formControlName="allocated_room_number"
               placeholder="Room number"
               class="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white" />
        <p class="mt-1 text-xs text-gray-500 dark:text-gray-400">
          Use the room number shown on the room card.
        </p>
      </div>
    }
  </form>

  @if (!isAddMode && context.guest) {
    <div modal-footer-left>
      <button type="button"
              class="text-sm text-red-600 hover:text-red-700 dark:text-red-400 dark:hover:text-red-300"
              [disabled]="processing"
              (click)="unassign()">
        Unassign from room
      </button>
    </div>
  }
</app-modal>
